<template>
  <qx-card title="应收逾期信息">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="" v-if="(
                    scope.row.payConfirm === 1 &&
                    scope.row.isAutoMatic === 0
                  ) || (
                    scope.row.userType === 6 &&
                    scope.row.verificationState !== 2 &&
                    scope.row.isAutoMatic === 0 &&
                    o.busiId !== 21000023 &&
                    scope.row.busiId!=21000023
                  )
                ">
                  <span class="primary cur" @click="sure(scope.row.flowId)">确认收款</span>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  accountExpireGet, // 列表
  accountExpireGetSure, // 确认收款
} from 'api/user';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单号',
          },
          {
            prop: 'createDate',
            label: '发车时间',
          },
          {
            prop: 'name',
            label: '付款方',
          },
          {
            prop: 'sumTxnFeeDouble',
            label: '金额',
          },
          {
            prop: 'busiIdName',
            label: '产生业务',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: accountExpireGet,
    async sure (flowId) {
      const confirmRes = await this.$confirm('确认线下已收到款项？确认后，将减少您的应收金额。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await accountExpireGetSure({
          flowId,
        });
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
